import React from 'react';
import { StyledBigImage, DisplayWindowLink, ImageContainer } from './BigImage.styles';
import PropTypes from 'prop-types';
import { getContentUrl } from '../../utils/contentoUtils';
import LiveBadge from './components/LiveBadge/LiveBadge';
import HeroImage from './components/HeroImage/HeroImage';
import Caption from './components/Caption/Caption';

const BigImage = ({ item, onAfterClick, currentAccessibilityChoiceContento, className }) => {
    if (!item) {
        return null;
    }

    const url = getContentUrl(item.item, currentAccessibilityChoiceContento);
    const byline = item.byline;
    const heading = item.heading;

    return (
        <StyledBigImage data-rt="display-window-big-image" className={className}>
            <DisplayWindowLink
                className="lp_pos1"
                to={url}
                onAfterClick={(e) => onAfterClick(e, 1, item.item.svtId)}
            >
                <ImageContainer>
                    <HeroImage item={item}>
                        <LiveBadge item={item} />
                    </HeroImage>
                </ImageContainer>
                <Caption byline={byline} heading={heading} subHeading={item.subHeading} />
            </DisplayWindowLink>
        </StyledBigImage>
    );
};

BigImage.propTypes = {
    item: PropTypes.object.isRequired,
    onAfterClick: PropTypes.func,
    currentAccessibilityChoiceContento: PropTypes.string,
    className: PropTypes.string,
};

export default BigImage;
